<div class="custom-markdown">
  <markdown [data]="data"></markdown>
</div>
